<template>
  <div class="summary-complaints" v-loading="loading">
    <template v-if="showPlace">
      <el-form-item label="客诉小结单"></el-form-item>
    </template>
    <template v-else>
      <div class="complaints" v-if="!isEmpty">
        <h3 class="title">客诉表单区</h3>
        <ele-form
          label-width="182px"
          ref="summary-complaints-form"
          :form-data="dataValue"
          v-bind="formConfig"
          :formSchema="formSchema"
          @input="changeData"
        ></ele-form>
      </div>
    </template>
  </div>
</template>

<script>
import { crmRequest, isEmpty } from '@meta-vue/util'
import formMixin from '@meta-vue/vue-ele-form/lib/mixins/formMixin'
import { transform2Schema, matchControls, getCascaderOptionsMap, getVisibleFormItemList } from './utils'
import eleForm from '@meta-vue/vue-ele-form'
import Decimal from 'decimal.js'
import _ from 'lodash'
// --------
// import CxNumberInput from '@meta-vue/number-input'
// import vue from 'vue'
// vue.component('CxNumberInput', CxNumberInput)
// --------
export default {
  name: 'SummaryComplaints',

  mixins: [formMixin],
  components: {
    eleForm
  },

  props: {
    value: {
      type: [String, Array]
    },
    showPlaceHolder: {
      type: Boolean,
      default: false
    }
    // complaintType: String,
  },

  data() {
    return {
      loading: false,
      formConfig: {
        labelWidth: '130px',
        labelPosition: 'right',
        span: '24',
        isShowSubmitBtn: false,
        isShowBackBtn: false,
        formAttrs: {
          size: 'small'
        }
      },
      template: {}, // 接口数据模板
      formSchema: {},
      dataValue: {},
      controlList: [],
      amountKeyMap: {}
    }
  },

  computed: {
    isEmpty() {
      return Object.keys(this.formSchema)?.length === 0
    },
    showPlace() {
      return (this.formItemSchema.attrs && this.formItemSchema.attrs.showPlaceHolder) || this.showPlaceHolder
    }
  },

  watch: {
    'attrs.complaintType': {
      immediate: true,
      handler: function(complaintTypeId) {
        if (!complaintTypeId) {
          this.formSchema = {}
          return
        }
        this.getComplaintTemplate({ complaintTypeId })
      }
    },
    value: {
      handler(newVal) {
        // console.log(value, 'watch-----watch')
        if (newVal) {
          this.setDefaultData('update')
        }
      },
      immediate: true
    }
  },

  methods: {
    // 数据结构会有 ['{xxx}'] 、 { xxx } 、 '{xxx}'等场景
    formatDefaultData() {
      let data = _.cloneDeep(this.value)
      // console.log('处理数据', data)
      if (Array.isArray(data)) {
        data = data[0] || {}
      }
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data)
        } catch (error) {
          console.info(error, 'JSON解析失败')
        }
      }
      // console.log('处理数据2', data)
      return data
    },
    setDefaultData(flag) {
      console.log(this.value, { ...this.formSchema }, this.isEmpty, flag, this.dataValue, 'setDefaultData')
      if (this.value) {
        if (this.isEmpty) return
        let data = this.formatDefaultData()
        // console.log('有效值', data)
        try {
          data = Object.keys(this.formSchema || {}).reduce((prev, key) => {
            const item = this.formSchema[key]
            const defaultValue = data[key]
            let options = item.options || item.defaultOptions || []
            if (_.isFunction(options)) {
              try {
                options = options?.(data) || item.defaultOptions || []
              } catch (error) {
                console.info(error, '执行options异常')
                options = item.defaultOptions || []
              }
            }
            // 判断回填数据是否有效
            if (item.type === 'select') {
              if (options.some?.(c => c.value == defaultValue)) prev[key] = defaultValue
            } else if (item.type === 'cascader') {
              const calcValues = getCascaderOptionsMap(item.options) || []
              // console.log(calcValues, 'getCascaderOptionsMap')
              if (calcValues.includes(defaultValue?.join?.('-'))) prev[key] = defaultValue
            } else if (item._type === 'amount') {
              if (defaultValue && !isNaN(parseFloat(defaultValue)) && isFinite(defaultValue)) {
                prev[key] = new Decimal(defaultValue).div(100).toNumber()
              }
            } else {
              prev[key] = defaultValue
            }
            return prev
          }, {})
          console.log(data, '解析后的data')
          this.dataValue = data
        } catch (error) {
          console.info(error, '执行异常')
        }
      }
    },
    async getComplaintTemplate(data = {}) {
      if (this.showPlace) return
      let schema = {}
      this.loading = true
      try {
        const result = await crmRequest('/cust-complain-app/complaints/dynamic-form/detail/complaint-type', {
          method: 'get',
          params: data,
          getter: {
            successCode: true,
            code: 'success'
          }
        })
        this.template = {
          id: result?.id,
          version: result?.version,
          componentList: result?.componentList
        }
        this.controlList = result?.controlList
        schema = this.filterComplaintType(transform2Schema(result || {}) || {})
        console.log(result, schema, '表单schema配置')
        // this.$nextTick(() => {
        this.formSchema = schema
        if (!isEmpty(this.value)) this.setDefaultData('sync')
        // })
      } catch (error) {
        console.info(error)
        this.formSchema = {}
        this.template = {}
      } finally {
        this.loading = false
      }
    },
    /**过滤掉除了 上传 表单类型 */
    filterComplaintType(schema = {}) {
      return Object.keys(schema)?.reduce((prev, key) => {
        const item = schema[key]
        if (this.checkComponent(item)) prev[key] = item
        if (item._type === 'amount') {
          this.amountKeyMap[key] = true
        }
        return prev
      }, {})
    },
    checkComponent(item = {}) {
      if (['select', 'date', 'cascader', 'input', 'CxUpload'].includes(item.type)) return true
      if (item.type === 'form-custom' && ['CxNumberInput'].includes(item.is)) return true
      return false
    },
    changeData() {
      // console.log('通知数据变更1', this.value, { ...this.dataValue })
      if (this.isEmpty) return
      try {
        const data = Object.keys(this.dataValue)?.reduce?.((prev, key) => {
          const value = this.dataValue[key]
          if (this.amountKeyMap[key] && value && !isNaN(parseFloat(value)) && isFinite(value)) {
            prev[key] = new Decimal(value).times(100).toNumber()
          } else {
            prev[key] = value
          }
          return prev
        }, {})
        // console.log('通知数据变更2', { ...this.dataValue }, data)
        this.$emit('input', JSON.stringify(data))
      } catch (error) {
        console.error('formatData error', error)
      }
    },
    // 校验逻辑
    validateSummaryComplaints() {
      const formRef = this.$refs?.['summary-complaints-form']
      if (!formRef) return true
      return formRef?.validate()
    },
    resetSummaryComplaints() {
      const formRef = this.$refs?.['summary-complaints-form']
      formRef?.resetForm?.()
      formRef?.checkLinkage?.()
      this.dataValue = {}
    },
    // 对外暴露拓展参数
    getExtraData() {
      try {
        const result = matchControls(this.controlList, this.dataValue)
        const fullComponentList = getVisibleFormItemList(
          this.$refs?.['summary-complaints-form']?.formSchemaData,
          this.template.componentList
        )
        return JSON.stringify({ ...this.template, ...result, fullComponentList })
      } catch (error) {
        console.info(error)
        return ''
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.summary-complaints {

  .title {
    text-align center;
  }
  .complaints{
    padding: 0 20px;
    border-radius: 4px;
    background:rgb(246, 246, 246);
  }

  /deep/ .el-form-item__label {
    float: left !important;
  }
}
</style>
